// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._SuPEgEM4LsLGYdzVwBb{justify-content:space-between;align-items:center;margin-top:16px;display:flex}.dOlo3FbCJDMkIDLvbvyf{align-items:center;gap:12px;min-width:0;display:flex}.Ojb5hP0PNEUQwBFuomH9{background:var(--background-neutral-subtle);border-radius:4px;flex-shrink:0;width:32px;height:32px;overflow:hidden}.Z4ShEQ4O15EwBoT0ZTXE{flex-direction:column;justify-content:center;gap:5px;min-width:0;padding:10px 0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `_SuPEgEM4LsLGYdzVwBb`,
	"info": `dOlo3FbCJDMkIDLvbvyf`,
	"preview": `Ojb5hP0PNEUQwBFuomH9`,
	"meta": `Z4ShEQ4O15EwBoT0ZTXE`
};
export default ___CSS_LOADER_EXPORT___;
